import { Component, input } from '@angular/core';
import { PositioningService } from '../../dynamic-css/positioning.service';
import { NgxExtendedPdfViewerService } from '../../ngx-extended-pdf-viewer.service';
import { ResponsiveVisibility } from '../../responsive-visibility';

@Component({
    selector: 'pdf-toggle-secondary-toolbar',
    templateUrl: './pdf-toggle-secondary-toolbar.component.html',
    styleUrls: ['./pdf-toggle-secondary-toolbar.component.css'],
    standalone: false
})
export class PdfToggleSecondaryToolbarComponent {
  public showSecondaryToolbarButton = input<ResponsiveVisibility>(true);

  // #2818 modified by ngx-extended-pdf-viewer
  public disable = input<boolean>(false);
  // #2818 end of modification by ngx-extended-pdf-viewer

  constructor(public service: NgxExtendedPdfViewerService) {}

  public onClick = (event: Event): boolean => {
    event.preventDefault();
    const positioningService = new PositioningService();
    positioningService.positionPopupBelowItsButton('secondaryToolbarToggle', 'secondaryToolbar');
    return false;
  };
}
